import { currentViewModelSelect } from "../Helpers/StateAccessors/ViewModelSelect";

import { ModelHunk } from "./Core/ModelStoring/ModelHunk";
import { ModelActionType } from "./Core/ModelStoring/Store/modelActions";
import { FullFormAction } from "./Core/Store/FullFormAction";
import { FullFormState } from "./Core/Store/FullFormState";
import { TooltipsResolveActionType } from "./TooltipsResolveActions";

export function tooltipReducer(state: FullFormState, action: FullFormAction): FullFormState {
    if (action.type === TooltipsResolveActionType.DisableOwnTooltip) {
        return {
            ...state,
            errorLogTooltip: {
                errorId: action.payload.errorId,
                bindingPaths: action.payload.bindingPaths,
            },
        };
    } else if (action.type === TooltipsResolveActionType.EnableOwnTooltip) {
        return {
            ...state,
            errorLogTooltip: undefined,
        };
    } else if (action.type === ModelActionType.SetValues) {
        if (state.errorLogTooltip != undefined) {
            for (const [path, viewModelUpdate] of ModelHunk.iterateEntries(action.payload.values)) {
                if (state.errorLogTooltip.bindingPaths.includes(path)) {
                    if ("error" in viewModelUpdate || "warning" in viewModelUpdate) {
                        const viewModel = currentViewModelSelect.controlModel(state, path);
                        if (viewModel.error == undefined && viewModel.warning == undefined) {
                            return {
                                ...state,
                                errorLogTooltip: undefined,
                            };
                        }
                    }
                }
            }
        }
    } else if (action.type === TooltipsResolveActionType.DisableOwnTooltipAttachment) {
        return {
            ...state,
            errorLogTooltipAttachment: {
                errorId: action.payload.errorId,
                bindingPaths: action.payload.bindingPaths,
                attachmentId: action.payload.attachmentId,
                highlanderPath: action.payload.highlanderPath,
            },
        };
    } else if (action.type === TooltipsResolveActionType.EnableOwnTooltipAttachment) {
        return {
            ...state,
            errorLogTooltipAttachment: undefined,
        };
    }

    return state;
}
